module.exports = __webpack_public_path__ + "img/power_tower_small.567ecd0c.svg";